export default __webpack_public_path__ + "static/media/error-graphic.fd03c5a1.png";